import { Component, Inject } from '@angular/core'
import { ToastConfig } from '../../../shared/models/toast.interfaces'
import { SVG_ICON_SRC } from '../../injectors/svg-icon.injector'
import { ToastService } from '../../services/toast.service'

@Component({
    selector: 'app-toast-container',
    template: `
        <ngb-toast
            *ngFor="let toast of toasts"
            [class]="toast.classname"
            [class.toastIcon]="toast.icon"
            [autohide]="true"
            [delay]="toast.delay || 5000"
            (hidden)="remove(toast)"
            data-test="toast-box">
            <svg-icon *ngIf="toast.icon" [src]="pathIcons + toast.icon + '.svg'" svgClass="toast-icon"></svg-icon>
            <div>{{ toast.text | translate }}</div>
        </ngb-toast>
    `,
    host: { class: 'toast-container position-fixed bottom-0 end-0 p-3' },
    styleUrls: ['toast-container.component.scss']
})
export class ToastContainerComponent {
    constructor(
        private toastService: ToastService,
        @Inject(SVG_ICON_SRC) public readonly pathIcons: string
    ) {}

    remove(toast: ToastConfig): void {
        this.toastService.remove(toast)
    }

    get toasts(): ToastConfig[] {
        return this.toastService.toasts
    }
}
